<template>
  <v-container
    class="col-sm-8 col-sm-offset-2"
    data-aos="fade-up"
  >
    <h3
      class="text-center"
      :style="headerStyle"
      v-if="header"
    >{{header}}</h3>

    <template v-if="images.length">
      <v-row align="start" justify="center">
        <v-col
          class="d-flex child-flex"
          :cols="imgCols"
          :key="index"
          v-for="(image, index) in images"
        >
          <v-img
            aspect-ratio="1"
            class="mb-5"
            :position="image.position"
            :src="image.src"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
      </v-row>
    </template>

    <template v-if="section.images && section.images.length">
      <v-row align="start" justify="center">
        <v-col
          class="d-flex child-flex"
          :cols="imgCols"
          :key="index"
          v-for="(image, index) in section.images"
        >
          <v-img
            aspect-ratio="1"
            class="mb-5"
            :lazy-src="image.thumbnail"
            :position="image.position"
            :src="image.url"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
      </v-row>
    </template>

    <slot></slot>

    <v-row
      align="center"
      class="py-8"
      justify="center"
      v-if="link && linkText"
    >
      <v-btn
        class="text-center"
        depressed
        squared
        target="_blank"
        :class="{'white--text': linkColor}"
        :color="linkColor || 'primary'"
        :href="link"
      >{{linkText}}</v-btn>
    </v-row>
    <template v-if="editable">
      <v-overlay
        absolute
        opacity="0.2"
        :value="editable"
      >
        <v-row align="start" justify="center" class="mb-1">

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                @click="emitAction('title')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-format-title</v-icon>
              </v-btn>
            </template>
            <span>Title</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                @click="emitAction('images')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-image-edit</v-icon>
              </v-btn>
            </template>
            <span>Images</span>
          </v-tooltip>
          <template v-if="section.type === 'split'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  @click="emitAction('editLeftText')"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-text</v-icon>
                </v-btn>
              </template>
              <span>Left Text</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  @click="emitAction('editRightText')"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-text</v-icon>
                </v-btn>
              </template>
              <span>Right Text</span>
            </v-tooltip>
          </template>
          <template v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  @click="emitAction('text')"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-text</v-icon>
                </v-btn>
              </template>
              <span>Text</span>
            </v-tooltip>
          </template>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                @click="emitAction('link')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-link</v-icon>
              </v-btn>
            </template>
            <span>Link</span>
          </v-tooltip>
        </v-row>

        <v-row align="start" justify="center">

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                @click="emitAction('addSection')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Add Section</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                @click="emitAction('addProfiles')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-account</v-icon>
              </v-btn>
            </template>
            <span>Add Profiles</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                @click="emitAction('moveUp')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
            </template>
            <span>Move Up</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                @click="emitAction('moveDown')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </template>
            <span>Move Down</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                @click="emitAction('delete')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-row>

      </v-overlay>
    </template>

  </v-container>
</template>

<script>
import {
  VBtn,
  VCol,
  VContainer,
  VIcon,
  VImg,
  VOverlay,
  VProgressCircular,
  VRow,
  VTooltip,
} from 'vuetify/lib'

export default {
  components: {
    VBtn,
    VCol,
    VContainer,
    VIcon,
    VImg,
    VOverlay,
    VProgressCircular,
    VRow,
    VTooltip,
  },
  computed: {
    headerStyle() {
      return {
        'color': this.headerColor,
        'font-weight': 'bold',
      }
    },
    imgCols() {
      if ((this.section.images && this.section.images.length === 1)
          || this.images.length === 1) {
        return this.$vuetify.breakpoint.smAndUp ? '8' : '12'
      }
      // return this.$vuetify.breakpoint.xsOnly ? '12' : '6'
      return '6'
    }
  },
  data: () => ({
    overlay: false
  }),
  methods: {
    emitAction(action) {
      this.$emit('action', {
        'action': action,
        'index': this.index,
        'section': this.section,
      })
    },
  },
  props: {
    editable: {
      default: false,
      type: Boolean,
    },
    images: {
      default() {
        return []
      },
      type: Array,
    },
    header: {
      default: null,
      type: String,
    },
    headerColor: {
      default: 'black',
      type: String,
    },
    index: {
      default: null,
      type: Number,
    },
    link: {
      default: null,
      type: String,
    },
    linkText: {
      default: '',
      type: String,
    },
    linkColor: {
      default: '',
      type: String,
    },
    section: {
      default() {
        return {}
      },
      type: Object,
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  font-size: 30px;
  text-transform: uppercase;
  padding-top: 20px;
}
</style>
